import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import AutoPhotoSlider from './AutoPhotoSlider';

const totalSlides = 10; 
const slides = Array.from({ length: totalSlides }).map((_, idx) => ({
  image: `/images/slides/slide${idx + 1}.jpg`, // slide1.jpg, slide2.jpg, etc.
  title: `Auto Photo Slider Slide ${idx + 1}`,
  caption: `Auto Photo Slider Slide ${idx + 1}`,
}));

// const slides = [
//   { image: "/images/SJ_Gallery/SQ_1_11.jpg", title: "Welcome to SJ Swimming", caption: "Learn from the best coaches." },
//   { image: "/images/SJ_Gallery/LTS_2_1.jpg", title: "Our Beautiful Pools", caption: "Heated pools available year-round." },
//   { image: "/images/SJ_Gallery/SQ_1_5.jpg", title: "Join Our Classes", caption: "From beginners to advanced swimmers." },
// ];

const HeroSection = () => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16 / 9',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {/* Slider Background */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -2,
          }}
        >
          <AutoPhotoSlider slides={slides} />
        </Box>

        {/* Overlay for Opacity Control */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(0, 0, 0, 0.43)'
              : 'rgba(255, 255, 255, 0.3)',
            zIndex: -1,
            maxHeight: '100vh', 
          }}
        />

        {/* Hero Content */}
        <Box
          sx={{
            zIndex: 1,
            px: 2,
            mb:5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 'bold',
              mb: 2,
              color: theme.palette.primary.main,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' }, // Slightly smaller
            }}
          >
            Welcome
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              color: theme.palette.primary.main,
              fontSize: { xs: '0.9rem', sm: '1.3rem', md: '1.8rem' }, // Slightly smaller
            }}
          >
            What are you waiting for?
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              variant="outlined"
              size="large"
              href="/programs"
              sx={{
                color: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.background.default,
                },
                fontSize: { xs: '0.65rem', sm: '0.85rem' }, // 👌 smaller font size
                py: { xs: 0.6, sm: 1 }, // smaller vertical padding
                px: { xs: 1.5, sm: 3 }, // smaller horizontal padding
              }}
            >
              Programs
            </Button>
            <Button
              variant="contained"
              size="large"
              href="/contact-us"
              sx={{
                color: theme.palette.primary.default,
                borderColor: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                },
                fontSize: { xs: '0.65rem', sm: '0.85rem' }, // 👌 smaller font size
                py: { xs: 0.6, sm: 1 },
                px: { xs: 1.5, sm: 3 },
              }}
            >
              Contact Us
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeroSection;